import { Backdrop, CircularProgress, createStyles, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { SDialogButton } from './BCommonComponents';
import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

export interface ConfirmDialogProps {
	open: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: '#fff',
		},
	}),
);

export interface spinnerMuiSetter {
	setShowSpinner: React.Dispatch<React.SetStateAction<boolean>>,
}

export const SpinnerMuiContext = React.createContext<spinnerMuiSetter>({
	setShowSpinner: () => {
	}
});

export const SpinnerMui = (props: ConfirmDialogProps) => {
	const {open} = props;
	const classes = useStyles();

	return (
		<Backdrop className={classes.backdrop} open={open}>
			<CircularProgress color="inherit"/>
		</Backdrop>
	);
}
